import moment, { Moment } from 'moment';

const formatDate = (
  dateValue: Moment | undefined | null,
  country: string,
  format: string | undefined | null
) => {
  const valueArray = moment(dateValue?.locale('en')).toArray();
  const year = valueArray[0];
  const month = valueArray[1];
  const day = valueArray[2];

  const USCAFormat = `${month + 1 < 10 ? `0${month + 1}` : month + 1}/${
    day < 10 ? `0${day}` : day
  }/${year}`;

  const AUFormat = `${day < 10 ? `0${day}` : day}/${
    month + 1 < 10 ? `0${month + 1}` : month + 1
  }/${year}`;

  if (!format) {
    if (country === 'AU') {
      return AUFormat;
    } else {
      return USCAFormat;
    }
  } else {
    if (format === 'AU') {
      return AUFormat;
    }
    return USCAFormat;
  }
};

export default formatDate;
